/**
 * 医生管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>医生管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userkey" placeholder="输入姓名/部门"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="doctor_name" align="center" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="doctor_sex" align="center" label="性别" width="60">
        <template slot-scope="scope">
            <div v-if="scope.row.doctor_sex == 1">男</div>
            <div v-else-if="scope.row.doctor_sex == 2">女</div>
            <div v-else>未知</div>
        </template>
      </el-table-column>
      <el-table-column prop="department_name" label="部门" width="200">
      </el-table-column>
      <el-table-column prop="doctor_id" align="center" label="医生编码" width="100">
      </el-table-column>
      <el-table-column prop="can_reservation" align="center" label="可否挂号" width="100">
        <template slot-scope="scope">
            <div v-show="scope.row.can_reservation == 1">是</div>
            <div v-show="scope.row.can_reservation == 0">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="doctor_title" label="职称" width="160">
      </el-table-column>
      <el-table-column prop="shanchang" label="擅长">
      </el-table-column>
      <el-table-column prop="doctorinfo" label="医生介绍">
      </el-table-column>
      <el-table-column prop="is_show" align="center" label="是否显示" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_show" active-value="1" inactive-value="0" @change="setswitch('is_show',scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editDoctor(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑医生信息 -->
    <el-dialog title="医生信息" :visible.sync="doctorinfoVisible">
      <el-form :model="form">
        <el-form-item label="医生头像">
          <el-upload
            class="avatar-uploader"
            action="/api/system/uploadImg"
            :headers="upheader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.doctorpic" :src="form.doctorpic" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="border: 1px dashed #d9d9d9;"></i>
          </el-upload>
          <el-button v-if="form.doctorpic" @click="removepic" type="danger" icon="el-icon-close" circle style="padding: 5px;position: relative;left: 150px;top: -20px;"></el-button>
        </el-form-item>
        <el-form-item label="擅 长">
          <el-input type="text" v-model="form.shanchang" style="width: 80%;margin-left: 24px;"></el-input>
        </el-form-item>
        <el-form-item label="医生简介">
          <el-input type="textarea" v-model="form.doctorinfo" style="width: 80%;"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { doctorlist,doctorInfo,updateDoctorinfo } from '../../api/baseset'

  export default {
    data() {
      return {
            loading: false, //是显示加载
            doctorinfoVisible: false,
            formInline: {
              page: 1,
              limit: 10
            },
            imageUrl: '',
            listData: [], //表格数据
            form: {
              doctorpic: '',
              doctorinfo: ''
            },
            // 分页参数
            pageparm: {
              currentPage: 1,
              pageSize: 10,
              total: 10
            },
            upheader: {
              token: localStorage.getItem('logintoken')
            }
          }
    },
    // 注册组件
    components: {
      Pagination
    },
    created(){
      this.getdata(this.formInline);
    },
    methods:{
      getdata(parameter) {
        this.loading = true
        doctorlist(parameter).then(res => {
            console.log(res);
            this.loading = false
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      // 重置搜索
      formReset() {
        this.formInline.userkey = '';
      },
      // 图片上传
      handleAvatarSuccess(res, file) {
        this.form.doctorpic = res.data;
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const imgarr = ['image/jpeg','image/png','image/jpg','image/gif'];
        const isImg = imgarr.indexOf(file.type) !== -1;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImg) {
          this.$message.error('上传文件格式不正确，请上传图片！');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isImg && isLt2M;
      },
      editDoctor(row) {
        this.form = row;
        this.doctorinfoVisible = true;
      },
      removepic() {
        this.form.doctorpic ='';
      },
      setswitch(type,row) {
        var data = {}
        if(type == 'is_show'){
          data = {doctorid:row.doctor_id,is_show:row.is_show}
        }
        if(type == 'top'){
          data = {doctorid:row.doctor_id,top:row.top}
        }
        updateDoctorinfo(data).then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      submitform() {
        let data = {doctorid:this.form.doctor_id,doctorname:this.form.doctor_name,doctorinfo:this.form.doctorinfo,doctorpic:this.form.doctorpic,shanchang:this.form.shanchang}
        this.loading = true;
        doctorInfo(data).then(res => {
          this.loading = false;
          this.doctorinfoVisible = false;
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            });
          }else{
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false;
          this.deptinfoVisible = false;
          this.$message.error('修改失败，请稍后再试！')
        })
      }
    }

  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/base/Doctor.vue